"use client";

import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheVowExperience() {
  const particles = useMemo(() => {
    return Array.from({
      length: 30
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: `${Math.random() * 4 + 1}px`,
      animationDuration: `${Math.random() * 15 + 10}s`,
      animationDelay: `${Math.random() * 5}s`,
      opacity: Math.random() * 0.5 + 0.1
    }));
  }, []);
  return <section data-section-id="242830" id="the-vow-experience" className="relative w-full min-h-[70vh] flex items-center justify-center dark bg-background text-foreground overflow-hidden py-24">
      {}
      <style>
        {`
          @keyframes float-dust {
            0% {
              transform: translateY(0) translateX(0) scale(1);
              opacity: 0;
            }
            20% {
              opacity: var(--particle-opacity);
            }
            80% {
              opacity: var(--particle-opacity);
            }
            100% {
              transform: translateY(-150px) translateX(50px) scale(1.5);
              opacity: 0;
            }
          }
          .animate-dust {
            animation: float-dust linear infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background z-10" />
        {}
        <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] z-0">
           <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_watermark_logo.png" alt="VOW Watermark" className="w-[800px] h-auto grayscale" />
        </div>
        {particles.map((particle, i) => <div key={particle.id} data-index={i} className="absolute rounded-md bg-primary animate-dust z-0 blur-[1px]" style={{
        left: particle.left,
        top: particle.top,
        width: particle.size,
        height: particle.size,
        animationDuration: particle.animationDuration,
        animationDelay: particle.animationDelay,
        "--particle-opacity": particle.opacity
      } as React.CSSProperties} />)}
      </div>

      {}
      <div className="relative z-20 flex flex-col items-center text-center px-4 max-w-[800px] mx-auto">
        <h2 className="font-default text-5xl md:text-[64px] leading-tight mb-12 text-foreground tracking-tight">
          Experience the VOW Difference
        </h2>
        
        <div className="flex flex-col md:flex-row gap-6">
          <Link to="#">
            <Button variant="outline" size="lg" className="w-[300px] h-16 text-sm font-mono tracking-widest uppercase border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-500 rounded-md">
              Download Brochure
            </Button>
          </Link>

          <Link to="/BeginYourJourneyPage">
            <Button size="lg" className="w-[300px] h-16 text-sm font-mono tracking-widest uppercase bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/10 transition-all duration-500 hover:scale-105 rounded-md">
              Book a Visit
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}